export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const PASSWORD_FORGET = '/pw-forget';
export const HOME = '/home';
export const CONTACT = '/contact';
export const EDUCATION = '/education';
export const JAVASCRIPT = '/javascript';
export const SWIFT = '/swift';
export const DATA_SCIENCE ='/datascience';
export const BIG_DATA   ='/bigdata';
export const ARTIFICIAL_INTELIGENCE ='/ai';
export const MACHINE_LEARNING = '/machine';
export const ACCOUNT = '/account';
export const FOOTER = '/footer';


// WEBPACK FOOTER //
// ./src/constants/routes.js